/**
 * GalleryButton
 *
 * Unified interaction model — no device detection.
 * When selectable: click calls onSelect().
 * When not selectable (expand=false): renders a plain non-interactive wrapper
 * so touch/pointer events bubble freely to the parent Slick slider for swiping.
 */
import React from 'react';

export default function TouchGalleryButton({
  className = '',
  style,
  onSelect,
  selectable = true,
  children,
}) {
  if (!selectable) {
    // Not selectable — render a div so no click/pointer events are consumed
    return (
      <div className={className} style={style}>
        {children}
      </div>
    );
  }

  return (
    <button
      className={className}
      style={style}
      onClick={() => { if (onSelect) onSelect(); }}
    >
      {children}
    </button>
  );
}
